import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { updatePreferenceData } from "../../../../services/CommonService";
import Utils from "../../../../utils";

function Message(props) {

    const [emailSubject, setEmailSubject] = useState('');
    const [clientMessage, setClientMessage] = useState('');
    const [emailMessage, setEmailMessage] = useState('');

    useEffect(function () {

        setClientMessage((props?.preferenceData.client_portal_message) ? props?.preferenceData.client_portal_message : '');
        setEmailMessage((props?.preferenceData.email_message) ? props?.preferenceData.email_message : '');
        setEmailSubject((props?.preferenceData.email_subject) ? props?.preferenceData.email_subject : '');

    }, [props?.preferenceData]);

    const handleUpdateMessage = (e) => {
        e.preventDefault();

        if (!emailSubject.trim() && !clientMessage.trim() && !emailMessage.trim()) {
            toast.error('Please enter message any one');
        } else {

            props.setLoading(true);

            let updateList = [
                { slug: 'client_portal_message', value: clientMessage.trim() },
                { slug: 'email_subject', value: emailSubject.trim() },
                { slug: 'email_message', value: emailMessage.trim() },
            ];

            updatePreferenceData({ list: updateList })
                .then(response => {
                    props.setLoading(false);
                    toast.success(response.data.message);
                })
                .catch(err => {
                    props.setLoading(false);
                    toast.error(Utils.getErrorMessage(err));
                });
        }
    };

    return (
        <div className="tab-pane setting-tab-pane" id="Message" role="tabpanel">

            <div className="setting-card">

                {/* DEFAULT CLIENT PORTAL MESSAGE */}
                <div className="setting-section-title">
                    Default Client Portal Message
                </div>

                <p className="setting-text">
                    Please write the default client portal message.
                </p>

                <textarea
                    className="setting-textarea mt-2"
                    rows={8}
                    value={clientMessage}
                    onChange={(e) => setClientMessage(e.target.value)}
                ></textarea>


                {/* EMAIL SUBJECT */}
                <div className="setting-section-title mt-4">
                    Email Subject
                </div>

                <p className="setting-text">Please write the default email subject.</p>

                <input
                    type="text"
                    className="setting-input mt-2"
                    value={emailSubject}
                    onChange={(e) => setEmailSubject(e.target.value)}
                />


                {/* EMAIL MESSAGE */}
                <div className="setting-section-title mt-4">
                    Email Message
                </div>

                <p className="setting-text">
                    Please write the default email message.
                </p>

                <textarea
                    className="setting-textarea mt-2"
                    rows={10}
                    value={emailMessage}
                    onChange={(e) => setEmailMessage(e.target.value)}
                ></textarea>


                {/* BUTTON */}
                <div className="setting-btn-container mt-4">
                    <button
                        type="button"
                        onClick={handleUpdateMessage}
                        className="setting-btn-primary"
                    >
                        Update
                    </button>
                </div>

            </div>
        </div>

    );
}

export default Message;